var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-page"},[_vm._m(0),_c('base-foot',{attrs:{"type":2}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrap app-flex-mid-center"},[_c('img',{staticClass:"bg",attrs:{"src":require("../../../assets/contact.png")}})])
}]

export { render, staticRenderFns }